import React from "react";
import Login from "../../features/auth/Login";
import { Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import Footer from "../../components/Footer";
import ForgotPassword from "../../features/auth/ForgotPassword";
import ResetPassword from "../../features/auth/ResetPassword";

const UnAuthenticatedRoutes = () => {
  const token = localStorage.getItem("token");

  return (
    <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
      <Box sx={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/google-login-callback" element={<Login />} />
        </Routes>
      </Box>
      <Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default UnAuthenticatedRoutes;
